/* eslint-disable max-len */
import { FC } from 'react';

import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const PlusSubscriptionUnlimitedFeatureIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0605 8.06899C12.2741 7.93077 12.3495 7.85538 12.2867 7.6669C12.2239 7.47842 12.1485 7.42815 11.8595 7.45328L7.07203 7.96847C6.78303 7.9936 6.64481 8.00616 6.58198 8.10669C6.51915 8.20721 6.55685 8.34543 6.64481 8.60931L7.14742 10.1674C7.23538 10.4439 7.28564 10.5695 7.38617 10.6198C7.48669 10.67 7.62491 10.5946 7.86365 10.4439L12.0605 8.06899Z"
      fill="#272756"
    />
    <path
      d="M12.0592 6.59918C12.298 6.6997 12.3985 6.71227 12.5116 6.54892C12.6372 6.38557 12.6247 6.29761 12.4362 6.08399L9.1943 2.52797C9.00582 2.31436 8.9053 2.20127 8.79221 2.21384C8.66655 2.2264 8.59116 2.33949 8.41524 2.56567L7.4477 3.88504C7.27179 4.11122 7.1964 4.23687 7.23409 4.34996C7.27179 4.46305 7.39744 4.52588 7.66132 4.63897L12.0592 6.59918Z"
      fill="#272756"
    />
    <path
      d="M13.2401 5.74389C13.3029 5.9952 13.3532 6.08316 13.5542 6.08316C13.7553 6.08316 13.8181 6.02033 13.8809 5.74389L14.8485 1.03185C14.9113 0.755412 14.9364 0.617193 14.861 0.516669C14.7856 0.428711 14.6474 0.428711 14.3584 0.428711H12.7249C12.4359 0.428711 12.2977 0.428711 12.2223 0.516669C12.1469 0.604627 12.172 0.755412 12.2348 1.03185L13.2401 5.74389Z"
      fill="#272756"
    />
    <path
      d="M14.635 6.19607C14.4717 6.38455 14.4214 6.48508 14.5471 6.64843C14.6601 6.81178 14.7481 6.83691 15.012 6.71126L19.3973 4.72591C19.6612 4.61283 19.7868 4.55 19.8245 4.43691C19.8497 4.32382 19.7743 4.21073 19.5984 3.97199L18.6308 2.65261C18.4675 2.42644 18.3795 2.31335 18.2539 2.30078C18.1282 2.30078 18.0403 2.4013 17.8518 2.61492L14.635 6.19607Z"
      fill="#272756"
    />
    <path
      d="M15.0881 7.57863C14.8368 7.56606 14.7362 7.57863 14.6734 7.77968C14.6106 7.96816 14.6483 8.05612 14.887 8.19434L19.0713 10.5566C19.3226 10.6949 19.4483 10.7702 19.5488 10.7326C19.6619 10.6823 19.6996 10.5566 19.7876 10.2802L20.2902 8.72208C20.3781 8.44564 20.4158 8.31999 20.353 8.21947C20.2902 8.11894 20.1394 8.10638 19.8629 8.06868L15.0881 7.57863Z"
      fill="#272756"
    />
    <path
      d="M14.2331 8.75932C14.0948 8.5457 14.0194 8.47031 13.831 8.53314C13.6425 8.59596 13.5922 8.67136 13.6173 8.96036L14.1702 13.7352C14.1954 14.0242 14.2205 14.1625 14.321 14.2253C14.4215 14.2881 14.5598 14.2504 14.8236 14.1625L16.3692 13.6473C16.6456 13.5593 16.7713 13.5091 16.809 13.4085C16.8467 13.2954 16.7838 13.1698 16.6331 12.931L14.2331 8.75932Z"
      fill="#272756"
    />
    <path
      d="M4.87115 23.2979C3.90361 22.8078 3.92874 22.2424 4.46906 21.3628C6.94445 17.4298 10.1863 12.3157 12.1968 9.11148C12.3602 8.86017 12.8879 9.06122 12.7999 9.37536C11.1664 12.8434 8.64078 18.2968 6.66801 22.5565C6.17796 23.5492 5.78843 23.7502 4.87115 23.2979Z"
      fill="#272756"
    />
  </svg>
);
